module.exports = __webpack_public_path__ + "img/rustore.fdc18a80.jpg";